import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Synopsis from '@/components/Synopsis'
import OrgChart from '@/components/OrgChart'
import AboutWe from '@/components/AboutWe'
import ConNotice from '@/components/ConNotice'
import NewsSta from '@/components/newsSta'
import TestCenter from '@/components/TestCenter'
import CellSection from '@/components/CellSection'
import TeachVideo from '@/components/TeachVideo'
import PicStudy from '@/components/PicStudy'
import CaseCenter from '@/components/CaseCenter'
import Scholary from '@/components/ScholarlyLiterature'
import TeamExperts from '@/components/TeamExperts'
import SearchMsg from '@/components/SearchMsg'
import PersonalCenter from '@/components/PersonalCenter'
import HistoryRecord from '@/components/HistoryRecord'
import ExaminationResults from '@/components/ExaminationResults'
import InformationDetail from '@/components/InformationDetail'


Vue.use(Router)
const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/synopsis',
      name: 'Synopsis',
      component: Synopsis
    },
    {
      path: '/orgChart',
      name: 'OrgChart',
      component: OrgChart
    },
    {
      path: '/aboutWe',
      name: 'AboutWe',
      component: AboutWe
    },
    {
      path: '/conNotice',
      name: 'ConNotice',
      component: ConNotice
    },
    {
      path: '/newsSta',
      name: 'NewsSta',
      component: NewsSta
    },
    {
      path: '/testCenter',
      name: 'TestCenter',
      component: TestCenter
    },
    {
      path: '/cellSection',
      name: 'CellSection',
      component: CellSection
    },
    {
      path: '/teachVideo',
      name: 'TeachVideo',
      component: TeachVideo
    },
    {
      path: '/picStudy',
      name: 'PicStudy',
      component: PicStudy
    },
    {
      path: '/caseCenter',
      name: 'CaseCenter',
      component: CaseCenter
    },
    {
      path: '/scholary',
      name: 'Scholary',
      component: Scholary
    },
    {
      path: '/teamExperts',
      name: 'TeamExperts',
      component: TeamExperts
    },
    {
      path: '/searchMsg',
      name: 'SearchMsg',
      component: SearchMsg
    },
    {
      path: '/personalCenter',
      name: 'PersonalCenter',
      component: PersonalCenter
    },
    {
      path: '/historyRecord',
      name: 'HistoryRecord',
      component: HistoryRecord
    },
    {
      path: '/examinationResults',
      name: 'ExaminationResults',
      component: ExaminationResults
    },
    {
      path: '/examinationResults',
      name: 'ExaminationResults',
      component: ExaminationResults
    },
    {
      path: '/informationDetail',
      name: 'InformationDetail',
      component: InformationDetail
    },
    
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js